import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { CustomNumberFormatterPipe } from './pipes/custom-number-formatter.pipe';
import { LimitPipe } from './pipes/limit.pipe';
import { NestedFolderPipe } from './pipes/nested-folder.pipe';
import { TruncateTextPipe } from './pipes/truncate-text.pipe';

import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzAnchorModule } from 'ng-zorro-antd/anchor';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzCommentModule } from 'ng-zorro-antd/comment';
import { NzListModule } from "ng-zorro-antd/list";

// region: third libs
import * as echarts from 'echarts';
import { NgxEchartsModule } from 'ngx-echarts';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { CapitalizePipe } from "@shared/pipes/capitalize.pipe";
import { TeamScorecardService } from "@shared/services/team-scorecard.service";

import { ChartModule } from './components/chart/chart.module';
import { TablesModule } from "@shared/components/tables/tables.module";

import { TeamActivitiesReportComponent } from '@shared/components/widgets/team-activities-report/team-activities-report.component';
import { SonarCodeQualityWidgetComponent } from './components/widgets/sonar-code-quality-widget/sonar-code-quality-widget.component';
import { MetricsTableComponent } from './components/widgets/sonar-code-quality-widget/metrics-table/metrics-table.component';
import { IssuseOverivewTableComponent } from './components/widgets/sonar-code-quality-widget/issuse-overivew-table/issuse-overivew-table.component';
import { ExecutiveDashboardTrendReportsComponent } from './components/widgets/executive-dashboard-trend-reports/executive-dashboard-trend-reports.component';
import { NzTreeSelectModule } from "ng-zorro-antd/tree-select";
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { EmojiSelectorComponent } from '@shared/components/emoji-selector/emoji-selector.component';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzTransferModule } from 'ng-zorro-antd/transfer';
import { NzSpaceModule } from 'ng-zorro-antd/space';

const THIRD_MODULES = [
  NgxEchartsModule.forRoot({
    echarts
  }),
  NzTreeModule,
  NzAlertModule,
  NzTransferModule,
  NzAnchorModule,
  NzAvatarModule,
  NzSpaceModule,
  NzBreadCrumbModule,
  NzBadgeModule,
  NzButtonModule,
  NzCardModule,
  NzCarouselModule,
  NzCheckboxModule,
  NzCollapseModule,
  NzDatePickerModule,
  NzDividerModule,
  NzDrawerModule,
  NzDropDownModule,
  NzFormModule,
  NzIconModule,
  NzInputModule,
  NzInputNumberModule,
  NzLayoutModule,
  NzDescriptionsModule,
  NzMessageModule,
  NzModalModule,
  NzNotificationModule,
  NzPaginationModule,
  NzPopconfirmModule,
  NzProgressModule,
  NzRadioModule,
  NzResultModule,
  NzSelectModule,
  NzSkeletonModule,
  NzSpinModule,
  NzStepsModule,
  NzSwitchModule,
  NzSliderModule,
  NzTableModule,
  NzTabsModule,
  NzTagModule,
  NzToolTipModule,
  NzTypographyModule,
  NzUploadModule,
  NzPopoverModule,
  NzTimePickerModule,
  NzTimelineModule,
  NzEmptyModule,
  NzCommentModule,
  NzListModule,
  TablesModule,
  ChartModule,
];
// endregion

// region: your components & directives
const COMPONENTS = [];
const DIRECTIVES = [];
const PIPES = [
  CustomNumberFormatterPipe,
  LimitPipe,
  NestedFolderPipe,
  TruncateTextPipe,
  CapitalizePipe
];
// endregion

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    DragDropModule,
    // third libs
    ...THIRD_MODULES
  ],
  declarations: [
    // components and directives
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES,
    TeamActivitiesReportComponent,
    SonarCodeQualityWidgetComponent,
    MetricsTableComponent,
    IssuseOverivewTableComponent,
    ExecutiveDashboardTrendReportsComponent,
    EmojiSelectorComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    NgxPermissionsModule,
    ReactiveFormsModule,
    RouterModule,
    DragDropModule,
    // third libs
    ...THIRD_MODULES,
    // components and directives
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES,
    TeamActivitiesReportComponent,
    SonarCodeQualityWidgetComponent,
    MetricsTableComponent,
    ExecutiveDashboardTrendReportsComponent,
    EmojiSelectorComponent
  ],
  providers: [TeamScorecardService]
})
export class SharedModule {}
